<template>
  <v-card title="报销变更">
    <div class="grid-demo">
      <v-form slot="form">
        <v-row :gutter="24">
          <v-col class="gutter-row" span="24">
            <div style="text-align: left">
              <v-form-item>
                <v-input size="mini" placeholder="输入工号或姓名" v-model="cx"></v-input>
              </v-form-item>
              <v-form-item>
                <vxe-input
                  size="mini"
                  v-model="bxyf"
                  placeholder="报销月份"
                  type="month"
                  valueFormat="yyyyMM"
                ></vxe-input>
              </v-form-item>
              <v-form-item>
                <v-button type="primary" icon="search" @click="findList()"
                  ><span>检索</span></v-button
                >
                <v-button type="success" icon="plus" @click="lock()"
                  ><span>入账</span></v-button
                >
              </v-form-item>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <br />
    <vxe-grid
      v-bind="xGridOptions"
      size="mini"
      border
      stripe
      highlight-current-row
      highlight-hover-row
      ref="xTable"
      :data="tableData"
      show-footer
      :footer-method="footerMethod"
      row-id="id"
      @checkbox-change="checkboxChangeEvent"
      @checkbox-all="checkboxChangeEvent"
      @sort-change="sortChangeEvent"
    >
      <!--自定义插槽 cz-->
      <template v-slot:cz="{ row }">
        <span>
          <span>
            <a class="link" @click="add(row)" title="修改">
              <v-icon type="edit"></v-icon>
            </a>
            <!-- &nbsp;&nbsp;
            <v-popconfirm title="确定删除吗?" @confirm="del(row)" @cancel="cancel" placement="bottomRight">
              <a class="link" title="删除">
                <v-icon type="delete"></v-icon>
              </a>
            </v-popconfirm> -->
          </span>
        </span>
      </template>
      <template v-slot:empty>
        <span style="color: red">
          <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
  </v-card>
</template>
<script>
import { milliFormat } from "../../../static/js/milli_format.js";
let options = {
  id: "",
};
export default {
  data() {
    return {
      options,
      tableData: [],
      selectRecords: [],
      cx: "",
      bxyf:dateFormat("YYYYmm", new Date()),
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        height: 408,
        headerAlign: "center",
        checkboxConfig: {
          highlight: true,
          range: true,
          reserve: true,
          checkMethod: this.checCheckboxkMethod3
        },
        editConfig: {
          trigger: "", //click可以编辑表格
          mode: "row",
          showStatus: true,
        },
        columns: [
          { type: 'checkbox', width: 60,align: "center" },
          {
            type: "seq",
            title: "序号",
            width: 70,
            align: "center",
          },
          {
            field: "gh",
            title: "工号",
            align: "center",
          },
          {
            field: "xm",
            title: "姓名",
            align: "center",
          },
          {
            field: "khbh",
            title: "客户编号",
            align: "center",
          },
          {
            field: "khmc",
            title: "客户名称",
            align: "center",
          },
          {
            field: "bxyf",
            title: "报销月份",
            align: "center",
          },
          {
            field: "km_mc",
            title: "报销科目",
            align: "center",
          },
          {
            field: "bx_je",
            title: "报销金额",
            headerAlign:"center",
            align: "right",
            formatter: this.formatterAmount,
          },
          {
            field: "bx_ms",
            title: "报销理由",
            align: "center",
          },
          {
            field: "wc_bj",
            title: "是否锁定",
            align: "center",
            slots: {
              default: ({ row, column }) => {
                let sd = row.wc_bj == 1 ? "是" : "否"
                return [
                  <span>{sd}</span>
                ];
              }
            }
          },
          {
            field: "cz",
            title: "操作",
            align: "center",
            slots: {
              // 对应自定义插槽的名称
              default: "cz",
            },
          },
        ],
      },
    };
  },
  created() {
    if(this.$route.query.gh){
      this.cx = this.$route.query.gh;
    }
    if(this.$route.query.bxyf){
      this.bxyf = this.$route.query.bxyf;
    }
    this.findList();
  },
  methods: {
    findList() {
      if (this.bxyf == "") {
        this.$message["error"]("请选择报销月份！");
        return;
      }
      this.$axios.get("api/system/bx/get-bx-list?cx=" + this.cx+"&bxyf="+this.bxyf).then((res) => {
        this.tableData = res.data.data;
      });
    },
    add: function (row) {
      let id = row.id;
      let title = "修改报销";
      xadmin.open(title, "/bxadd?id=" + id, "600", "500");
    },
    checCheckboxkMethod3 (res) {
      if(res.row.wc_bj == "1"){
        return false;
      }else{
        return true;
      }
      },
    lock: function () {
      if(this.selectRecords.length == 0){
        this.$message["error"]("请勾选入账数据");
        return;
      }
      this.$axios
        .post("api/system/bx/lock" , this.selectRecords)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message["success"](res.data.message);
            this.findList()
          } else {
            this.$message["error"](res.data.message);
          }
        });
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (["bx_je"].includes(column.property)) {
            let sum = 0;
            data.forEach((item) => {
              sum += item.bx_je;
            });
            return milliFormat(sum);
          }
          return null;
        }),
      ];
    },
    checkboxChangeEvent({ checked,row,records }) {
      let self = this;
      this.isAllChecked = this.$refs.xTable.isAllCheckboxChecked()
      this.isIndeterminate = this.$refs.xTable.isCheckboxIndeterminate()
      this.selectRecords  = []
      //console.log(records)
      records.forEach(rec => {
        this.selectRecords.push(rec["id"])
      });
      // if(checked){
      //   this.selectRecords.push(records["id"])
      // }else{
      //   this.selectRecords.deleteElementByValue(records["id"])
      // }
      console.log(this.selectRecords);
    },
    sortChangeEvent({ column, property, order }) {
      (this.pagination.sort= property), (this.pagination.sorttype = order);
      this.findList();
    },
    formatterAmount(row) {
      return milliFormat(row.cellValue.toString());
    },
    // del: function (row) {
    //   this.$axios
    //     .get("api/system/rywh/del-rywh-list?gh=" + row.gh)
    //     .then((res) => {
    //       if (res.data.code == 200) {
    //         this.$message["success"](res.data.message);
    //         this.findList();
    //       } else {
    //         this.$message["error"](res.data.message);
    //       }
    //     });
    // },
    // cancel: function () {
    //   this.$message.info("取消删除");
    // },
  },
};
function dateFormat(fmt, date) {
  let ret;
  const opt = {
    "Y+": date.getFullYear().toString(), // 年
    "m+": (date.getMonth() + 1).toString(), // 月
    "d+": date.getDate().toString(), // 日
    "H+": date.getHours().toString(), // 时
    "M+": date.getMinutes().toString(), // 分
    "S+": date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
      );
    }
  }
  return fmt;
}
</script>


<style>
.vxe-footer--row {
  background-color: #ffbf00;
  color: black;
}
</style>


// WEBPACK FOOTER //
// src/view/bxgl/bx.vue